/**
 * @file 相关推荐卡片组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';
import RecItem from './rec-item';

export default class RecommendCard extends Component {
    static template = `
        <div class="recommend-card-wrap">
            <div class="title">相关推荐</div>
            <div class="list">
                <div class="left-column">
                    <template s-for="item, index in leftColumn">
                        <components-rec-item
                            reflow="{{reflow}}"
                            item="{{item}}"
                            on-itemclick="itemClick"
                            on-likeclick="likeClick" />
                    </template>
                </div>
                <div class="right-column">
                    <template s-for="item, index in rightColumn">
                        <components-rec-item
                            reflow="{{reflow}}"
                            item="{{item}}"
                            on-itemclick="itemClick"
                            on-likeclick="likeClick" />
                    </template>
                </div>
            </div>
            <div class="more-btn" s-if="reflow" on-click="moreClick">更多精彩内容移步APP</div>
        </div>
    `;

    static components = {
        'components-rec-item': RecItem
    };

    initData() {
        return {
            leftColumn: [],
            rightColumn: []
        };
    }

    attached() {
        // 计算不规则流式分布策略
        const list = this.data.get('list');
        let leftColumn = [list[0]];
        let rightColumn = [list[1]];
        // 左侧列表高度
        let leftH = this.calculateHightDiff(list[0]);
        // 右侧列表高度
        let rightH = this.calculateHightDiff(list[1]);
        list.slice(2).forEach(item => {
            if (leftH > rightH) {
                rightColumn.push(item);
                rightH = rightH + this.calculateHightDiff(item);
            }
            else {
                leftColumn.push(item);
                leftH = leftH + this.calculateHightDiff(item);
            }
        });

        this.data.set('leftColumn', leftColumn);
        this.data.set('rightColumn', rightColumn);
    }

    // 计算每个卡片的高度diff
    calculateHightDiff(item) {
        let res = 0;
        let ratio = (item.cover.width / item.cover.height) <= 0.8125 ? 1.33 : 1;
        // 根据类型计算封面高度
        res += ratio * 558;

        let strlen = 0;
        for (let i = 0; i < item.title.length; i++) {
            // 如果是汉字，则宽为
            if (item.title.charCodeAt(i) > 255) {
                strlen += 48;
            }
            else {
                strlen += 24;
            }
        }

        // 558-60=498,为实际宽度
        if (strlen > 498) {
            // 72为行高，通常一行，最多两行
            res += 72;
        }
        return res;
    }
    // 查看更多
    moreClick() {
        this.fire('moreclick');
    }

    // 点击卡片
    itemClick(item) {
        this.fire('itemclick', item);
        if (!this.data.get('reflow')) {
            location.href = item.jumpUrl;
        }
    }

    // 点赞
    likeClick(item) {
        this.fire('likeclick', item);
    }
}
